import React, { useState, useEffect } from 'react';
import './SearchForm.css';

function SearchForm({ onSearch, onDownload, loading, status, currentMeta }) {
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (currentMeta?.url) {
      setUrl(currentMeta.url);
    }
  }, [currentMeta]);

  const trimmedUrl = url.trim();
  const readyToDownload = !!currentMeta && trimmedUrl === currentMeta.url;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(trimmedUrl);
  };

  return (
    <form className="search-form" onSubmit={handleSubmit}>
      <div className="search-status">
        {status && (status.type === 'success' || status.type === 'error') && (
          <div className={`status status-${status.type}`}>{status.message}</div>
        )}
      </div>
      <div className="input-group">
        <label htmlFor="youtubeUrl">YouTube link</label>
        <input
          id="youtubeUrl"
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://www.youtube.com/watch?v=..."
          disabled={loading}
        />
      </div>
      <div className="action-buttons">
        <button type="submit" className="btn btn-primary" disabled={loading || !trimmedUrl}>
          Search
        </button>
        <button
          type="button"
          className="btn btn-download"
          onClick={onDownload}
          disabled={loading || !readyToDownload}
        >
          Download MP3
        </button>
      </div>
    </form>
  );
}

export default SearchForm;
